import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import { PROCESS_STEPS } from "../data/siteContent";

export default function Process() {
  return (
    <section id="process" className="relative bg-ink-soft py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Process"
          title="A proven creative"
          titleAccent="workflow"
          subtitle="From strategy to market — structured, transparent, and built for results."
        />
        <div className="relative">
          <div className="absolute left-8 top-0 hidden h-full w-px bg-gradient-to-b from-accent via-white/20 to-transparent lg:left-1/2 lg:block" />
          <motion.div className="space-y-8 lg:space-y-12">
            {PROCESS_STEPS.map((step, i) => (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, x: i % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6 }}
                className={`relative flex flex-col gap-6 lg:flex-row lg:items-center ${
                  i % 2 === 1 ? "lg:flex-row-reverse" : ""
                }`}
              >
                <div className="lg:w-1/2 lg:pr-12">
                  <motion.article
                    whileHover={{ scale: 1.02 }}
                    className="rounded-2xl border border-white/10 bg-ink-card p-8 shadow-card"
                  >
                    <span className="font-sans text-4xl font-bold text-accent/40">{step.step}</span>
                    <h3 className="mt-2 font-sans text-2xl font-bold text-white">{step.title}</h3>
                    <p className="mt-3 text-white/60">{step.desc}</p>
                  </motion.article>
                </div>
                <div className="hidden lg:block lg:w-1/2" />
                <div className="absolute left-6 top-8 hidden h-4 w-4 rounded-full border-4 border-ink bg-accent lg:left-1/2 lg:-translate-x-1/2 lg:block" />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}

